import { DateTime } from 'luxon';

export function cleanTime(time:string) 
{
	const format = formatDateTime(time,'mm') == '00' ? 'ha' : 'h:mma';
	return formatDateTime(time,format);
}

export function weekday(day) 
{
	const dayMap = {
		mon:'Monday', 
		tue:'Tuesday', 
		wed:'Wednesday', 
		thu:'Thursday', 
		fri:'Friday', 
		sat:'Saturday', 
		sun:'Sunday'
	};

	return dayMap[day];
}

export function week(week) 
{
	const weekMap = {
		first:'1st', 
		second:'2nd', 
		third:'3rd', 
		fourth:'4th', 
		last:'Last'
	};

	return weekMap[week];
}

export function daysOfWeekly(days)
{
	/* Assumes days can't be repeated */
	if (days.length==5 && !days.includes('sat') && !days.includes('sun'))
		return 'Weekdays';

	let ret = '';
	let sep = '';

	for (const day of days) {
		ret += sep + weekday(day) + 's';
		sep = ', ';
	}

	return ret;
}

export function startTimeText(time,allDay,separator:string)
{
	if (!time || allDay)
		return '';

	return separator + cleanTime(time);
}

/* The plain text of a date title. Whitespace is collapsed the way HTML would render it. */
export function dateTitleText(frequency,startSingle,startTime,allDay,weekdays,days,weekCode,weekdayCode)
{
	let text:string;

	switch (frequency) {
		case 'once':
			text = startSingle
				? formatDateTime(startSingle,'EEE, dd LLL') + startTimeText(startSingle,false,' ')
				: '';
			break;

		case 'daily':
			text = 'Daily' + startTimeText(startTime,allDay,' ');
			break;

		case 'weekly':
			text = daysOfWeekly(weekdays) + ' ' + (days ?? '') + startTimeText(startTime,allDay,' ');
			break;

		case 'monthly':
			text = (week(weekCode) ?? '') + ' ' + (weekday(weekdayCode) ?? '') + ' of month'
				+ startTimeText(startTime,allDay,', ');
			break;

		default:
			text = '';
	}

	return text.replace(/\s+/g,' ').trim();
}

export function genreList(artist)
{
	/* poster macros need to return undefined when no data */
	if (!artist)
		return undefined;

	let sep = '',ret='';

	if (artist.mainGenre) { ret += artist.mainGenre; sep = ', '; }
	if (artist.otherGenre1) { ret += `${sep}${artist.otherGenre1}`; sep = ', '; }
	if (artist.otherGenre2) { ret += `${sep}${artist.otherGenre2}`; sep=', '; }
	if (artist.extraGenre) ret += `${sep}${artist.extraGenre}`;

	return ret;
}

export function formatDateTime(value:string|Date,format:string)
{
	//XXX backend events page sends us undefines initially for unknown reasons, causing problems. Hence the guards.
	if (!value)
		return '';

	try {
		const dt = value instanceof Date
			? DateTime.fromJSDate(value)
			: DateTime.fromISO(value);
		return dt.toFormat(format);
	}
	catch(err) {
		log.error(err);
		return '';
	}
}	

/*
	Combine the genres from multiple artists.
	Interleaving the genres from the artists - giving primacy to the earlier artists.
*/
export function combinedGenres(artists)
{
	/* poster macros need to return undefined when no data */
	if (!artists)
		return undefined;

	const genreSet = {};
	const fields = ['mainGenre','otherGenre1','otherGenre2','extraGenre'];

	for (const field of fields) 
		for (const artist of artists) 
			if (artist[field])
				genreSet[artist[field].toLowerCase()] = true;

	let sep = '',ret='';
	for (const key of Object.keys(genreSet)) {
		ret += `${sep}${key}`; 
		sep=', ';
	}

	return ret;
}

